import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../generic/number-format/TypeNumberFormat";
export var LeagueRewardDiscountBadge = function (_a) {
    var currentGift = _a.currentGift;
    var discountBadge = currentGift == undefined
        ? undefined
        : (currentGift.shownStat || []).find(function (element) {
            return element.bonusValue != undefined && element.valueType === "percentage";
        });
    if (discountBadge == undefined) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "dialog-league-reward-special-offer__badge" },
        React.createElement(Icon, { icon: IdIcon.BadgePremiumIcn, styleId: IdStyles.IconExtraLarge },
            React.createElement("div", { className: "flex flex--guts h100 w100 dialog-league-reward-special-offer__badge-content" },
                React.createElement(NumberFormat, { amount: discountBadge.bonusValue * 100, format: TypeNumberFormat.RoundedPercent, className: IdStyles.TextBoldSecondaryOutline })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/LeagueRewardDiscountBadge.tsx
// module id = 2946
// module chunks = 3